"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdleSessionTimeoutDialog = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_design_system_1 = require("@hdh-core/react-design-system");
const react_intl_1 = require("react-intl");
const IdleSessionTimeoutDialog = (_a) => {
    var props = __rest(_a, []);
    const { sessionTimeoutDialog, date, idleSessionTimeoutGracePeriodTimeout } = props;
    const intl = (0, react_intl_1.useIntl)();
    const [isOpen, setOpen] = (0, react_1.useState)(true);
    const [idleSessionDate, setIdleSessionDate] = (0, react_1.useState)(0);
    const [nextlogout, setNextlogout] = (0, react_1.useState)(0);
    const [countDownTimeMin, setcountDownTimeMin] = (0, react_1.useState)(0);
    const [countDownTimeSec, setcountDownTimeSec] = (0, react_1.useState)(0);
    const [timeId, setTimeId] = (0, react_1.useState)(null);
    let intervalId;
    (0, react_1.useEffect)(() => {
        const sessionData = props.getGlobalState().sessionData;
        setOpen(sessionTimeoutDialog);
        const idleSessionTimeoutGracePeriod = sessionData.Idle_Session_Timeout_Grace_Period;
        const sessionTimeOut = sessionData.Idle_Session_Time_Out;
        const idleDate = (sessionTimeOut - idleSessionTimeoutGracePeriod) / 60 / 1000;
        const idleLogout = idleSessionTimeoutGracePeriod / 60 / 1000;
        setIdleSessionDate(idleDate);
        setNextlogout(idleLogout);
    }, [date]);
    (0, react_1.useEffect)(() => {
        //if (isOpen == true) {
        //	setCountDonwTime(idleSessionTimeoutGracePeriodTimeout)
        //}
    }, [isOpen]);
    (0, react_1.useEffect)(() => {
        if (idleSessionTimeoutGracePeriodTimeout <= 0 || props.getGlobalState().sessionData.logout === true) {
            clearInterval(timeId);
            clearInterval(intervalId);
            setTimeId(() => null);
        }
        return () => clearInterval(intervalId);
    }, [intervalId, idleSessionTimeoutGracePeriodTimeout]);
    (0, react_1.useEffect)(() => {
        const tempCountDownTime = parseInt((idleSessionTimeoutGracePeriodTimeout / 60).toString());
        setcountDownTimeMin(tempCountDownTime);
        setcountDownTimeSec(idleSessionTimeoutGracePeriodTimeout % 60);
        if (idleSessionTimeoutGracePeriodTimeout <= 0 || props.getGlobalState().sessionData.logout === true) {
            clearInterval(timeId);
            clearInterval(intervalId);
            setTimeId(() => null);
        }
    }, [idleSessionTimeoutGracePeriodTimeout]);
    const onClickOK = () => {
        const globalState = Object.assign(Object.assign({}, props.getGlobalState()), { sessionData: Object.assign(Object.assign({}, props.getGlobalState().sessionData), { resetTimer: true }) });
        props.setGlobalState(globalState);
        setOpen(false);
    };
    const onClickCancel = () => {
        const globalState = Object.assign(Object.assign({}, props.getGlobalState()), { sessionData: Object.assign(Object.assign({}, props.getGlobalState().sessionData), { logout: true }) });
        props.setGlobalState(globalState);
        setOpen(false);
    };
    //const msg =
    //	'We notice you have been inactive for the past ' +
    //	idleSessionDate +
    //	' minutes. The system will auto-log out in the next ' +
    //	nextlogout +
    //	" minutes if no activity is detected. \n Click 'Ok' to continue this session."
    const str1 = intl.formatMessage({ id: 'idle-session-message-part1' });
    const str2 = intl.formatMessage({ id: 'idle-session-message-part2' });
    const str3 = intl.formatMessage({ id: 'idle-session-message-part3' });
    const msg = `${str1} ${idleSessionDate} ${str2} ${nextlogout} ${str3}`;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(react_design_system_1.ConfirmDialog, { isOpen: isOpen, setOpen: setOpen, title: intl.formatMessage({ id: 'idle-session-still-there-popup' }), iconType: 'reject', leftBtnLabel: intl.formatMessage({ id: 'idle-session-logout-btn' }), rightBtnLabel: intl.formatMessage({ id: 'session-time-out-btn-ok' }), onConfirmClick: onClickOK, onCancelClick: onClickCancel, message: msg, hasTimer: true, timerCounter: `${countDownTimeMin.toString()} : ${countDownTimeSec.toString().padStart(2, '0')}`, timerLabel: intl.formatMessage({ id: 'idle-session-time-auto-logout' }) })));
};
exports.IdleSessionTimeoutDialog = IdleSessionTimeoutDialog;
exports.IdleSessionTimeoutDialog.propTypes = {
    sessionTimeoutDialog: prop_types_1.default.bool
};
exports.IdleSessionTimeoutDialog.defaultProps = {
    sessionTimeoutDialog: false
};
exports.default = exports.IdleSessionTimeoutDialog;
